import Vue from 'vue'
import App from './App.vue'
import {BootstrapVue} from 'bootstrap-vue'
import VueScrollTo from 'vue-scrollto'
import {library} from '@fortawesome/fontawesome-svg-core'
import {faFileAlt} from '@fortawesome/free-regular-svg-icons'
import {faClock, faEnvelope, faPhoneAlt, faChevronDown,} from '@fortawesome/free-solid-svg-icons'
import {faFacebookF, faAppStoreIos, faGooglePlay, faYoutube} from '@fortawesome/free-brands-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import router from "./router";
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/css/main.css'
import store from './store'

library.add(faClock, faEnvelope, faPhoneAlt, faFacebookF, faChevronDown, faAppStoreIos, faGooglePlay, faFileAlt, faYoutube);

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.use(BootstrapVue);
Vue.use(VueScrollTo, {offset: -49});

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');
